/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Row, Col, Button } from 'reactstrap'

import Select from 'react-select';

import ConfirmationModal from '../../widgets/ConfirmationModal'
import { AppContext } from '../../AppContext'

class ObjectSharing extends React.Component
{
  confirmThisShareStatus = null;
  objectSharingPermissions = null;
  originallySelectedUsers = [];
  dissimilarShareStatusValues = false;
  shareStatusRef = React.createRef();
  usersToShareWithRef = React.createRef();

  closeModal = null;

  canModalClose()
  {
    if ('Share With Users' === this.state.shareStatus.permission && !this.state.selectedUsers.length && 'none' === this.state.resetShareStatusDisplay)
    {
      this.context.postNotification('warning', 'You have to specify one or more users to share this object with - or change the share status.');      
      return false;
    } 

    return true;
  }
  
  async checkSharedUserEquivalence()
  {
    let bodyData = {};
    bodyData.objectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) bodyData.objectIds.push(this.props.selectedObjects[x].objectId);

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'checkSharedUserEquivalence', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error checking for shared user equivalence');
    if ('true' === result.jsonData.sharedUserEquivalence)
    {
      this.getUsersToShareWith();
      this.getUsersObjectIsSharedWith();
      this.setState(
      { 
        resetShareStatusDisplay: 'none', 
        shareStatusDisplay: 'flex', 
        usersToShareDisplay: 'flex',
        sharedUserEquivalence: true,
      });
      if (null !== this.usersToShareWithRef.current) this.usersToShareWithRef.current.focus();
    }
    else
      this.setState({resetShareStatusDisplay: 'flex', shareStatusDisplay: 'none', sharedUserEquivalence: false});
  }

  componentDidMount()
  {
    this.objectSharingPermissions = this.context.userSession.getObjectSharingPermissions(this.context.userUiProfile.grantedPermissions);
    let shareStatusFocused = true;
    let usersToShareWithFocused = false;
    let usersToShareDisplay = 'none';
    let sharedUserEquivalence = true;
    let shareStatusDisplay = 'flex';
    let resetShareStatusDisplay = 'none';

    let shareStatus = this.props.selectedObjects[0].shareStatus;
    for (let x = 1; x < this.props.selectedObjects.length; x++)
    {
      if (shareStatus !== this.props.selectedObjects[x].shareStatus)
      {
        this.dissimilarShareStatusValues = true;
        shareStatus = 'Not Shared';
        resetShareStatusDisplay = 'flex';
        shareStatusDisplay = 'none';
        sharedUserEquivalence = false;
      }
    }

    if ('Share With Users' === shareStatus)
    {
      if (1 === this.props.selectedObjects.length)
      {
        usersToShareDisplay = 'flex';
        sharedUserEquivalence = true;
        shareStatusFocused = false;
        usersToShareWithFocused = true;
        this.getUsersToShareWith();
        this.getUsersObjectIsSharedWith();
      }
      else
      {
        sharedUserEquivalence = undefined;
        this.checkSharedUserEquivalence();
      }
    }

    this.setState(
    {
      shareStatus: {permission: shareStatus},
      shareStatusFocused: shareStatusFocused,
      sharedUserEquivalence: sharedUserEquivalence,
      usersToShareWithFocused: usersToShareWithFocused,
      usersToShareDisplay: usersToShareDisplay,
      shareStatusDisplay: shareStatusDisplay,
      resetShareStatusDisplay: resetShareStatusDisplay,
    });
  }

  confirmSetShareStatus(shareStatus, actionMetaD)
  {
    if (shareStatus.permission === this.state.shareStatus.permission) return;

    let modalText = 'Are you sure you want to change the way your are sharing this object?';
    this.closeModal = this.setShareStatusConfirmed.bind(this);
    this.confirmThisShareStatus = shareStatus;
    this.setState({modalText: modalText, confirmationModalIsOpen: true});
  }

  constructor(props)
  {
    super();

    let shareStatusFocused = true;
    let usersToShareWithFocused = false;
    let usersToShareDisplay = 'none';
    let sharedUserEquivalence = true;
    let shareStatusDisplay = 'flex';
    let resetShareStatusDisplay = 'none';
    let shareStatus = props.selectedObjects[0].shareStatus;

    this.state =
    {
      confirmationModalIsOpen: false,
      usersToShareWith: [],
      selectedUsers: [],
      shareStatus: {permission: shareStatus},
      shareStatusFocused: shareStatusFocused,
      sharedUserEquivalence: sharedUserEquivalence,
      usersToShareWithFocused: usersToShareWithFocused,
      usersToShareDisplay: usersToShareDisplay,
      shareStatusDisplay: shareStatusDisplay,
      resetShareStatusDisplay: resetShareStatusDisplay,
      modalText: undefined
    }

    this.confirmSetShareStatus = this.confirmSetShareStatus.bind(this);
    this.setShareStatusConfirmed = this.setShareStatusConfirmed.bind(this);
    this.setUsersToShareWith = this.setUsersToShareWith.bind(this);
    this.setNotShared = this.setNotShared.bind(this);
    this.usersToShareWithClosed = this.usersToShareWithClosed.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  async getUsersObjectIsSharedWith()
  {
    let bodyData = {objectId: this.props.selectedObjects[0].objectId};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getUsersObjectIsSharedWith', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting users this object is shared with');
    if (null === result.jsonData.usersObjectIsSharedWith) result.jsonData.usersObjectIsSharedWith = '[]';
    this.originallySelectedUsers = result.jsonData.usersObjectIsSharedWith;
    this.setState({selectedUsers: result.jsonData.usersObjectIsSharedWith});
  }

  async getUsersToShareWith()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getUsersWithViewSharedPriv');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting users to share with');
    this.setState({usersToShareWith: JSON.parse(result.jsonData.usersWithViewSharedPriv)});
  }

  onBlur(event)
  {
    if (!this.state.selectedUsers.length) event.preventDefault();
    if ('Share With Users' === this.state.shareStatus.permission && !this.state.selectedUsers.length)
    {
      this.closeModal = this.setNotShared.bind(this);
      this.setState(
      {
        modalText: 'You have not selected any users to share this object with.  If you continue, the status will revert back to Not Shared.',
        confirmationModalIsOpen: true
      });

      return;
    }
  }

  render()
  {
    let appContext = this.context;

    if (undefined === this.state.sharedUserEquivalence) return false;
    if ('Y' !== appContext.websiteProfile.sharingEnabled || !this.context.userSession.shareObjectsEnabled(this.context.userUiProfile.grantedPermissions)) return false;

    return (
      <div>
        <Row style={{display: this.state.resetShareStatusDisplay, paddingTop: "10px"}}>
          <Col sm={{ size: 8, offset: 2}}>
            <b>The objects you have selected do not have the same share settings.  If you proceed all of these objects will have their share setting set to 'Not Shared'.  You can then set the objects share setting to whatever you want it to be.</b>
          </Col>
        </Row>
        <Row style={{display: this.state.resetShareStatusDisplay, paddingTop: "10px"}}>
          <Col sm={{size: 3, offset: 2}}>
            <Button color="primary" onClick={this.setNotShared.bind(this, true)}>Set Not Shared</Button>
          </Col>
        </Row>
        <Row style={{display: this.state.shareStatusDisplay, paddingTop: "10px"}}>
          <Col sm="3">How do you want to share this object?</Col>
          <Col sm='3'>
            <Select value={this.state.shareStatus} options={this.objectSharingPermissions} onChange={this.confirmSetShareStatus}
              getOptionValue={option => option.permission} getOptionLabel={option => option.permission} blurInputOnSelect
              placeholder={'Not Shared'} className="basic-select" classNamePrefix="select" autoFocus={this.state.shareStatusFocused}
              ref={this.shareStatusRef}
            />
          </Col>
        </Row>
        <Row style={{paddingTop: "10px", display: this.state.usersToShareDisplay}}>
          <Col sm="3">Who do you want to share this object with?</Col>
          <Col sm='4'>
            <Select value={this.state.selectedUsers} options={this.state.usersToShareWith} onChange={this.setUsersToShareWith} isMulti
              getOptionValue={option => option.apiUserId} getOptionLabel={option => option.name}
              closeMenuOnSelect={false} placeholder={'Select some users...'} className="basic-multi-select" 
              classNamePrefix="select" onMenuClose={this.usersToShareWithClosed} autoFocus={this.state.usersToShareWithFocused}
              ref={this.usersToShareWithRef}
            />
          </Col>
        </Row>
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.closeModal} 
          modalText={this.state.modalText}
        />
      </div>
    );
  }

  async setNotShared(confirmed)
  {
    let shareStatus = (confirmed ? 'Not Shared' : this.state.shareStatus);
    this.setState({confirmationModalIsOpen: false, shareStatus: shareStatus});

    if (!confirmed)
    {
      this.setState({selectedUsers: this.originallySelectedUsers});
      this.shareStatusRef.current.focus();
      return;
    } 

    let bodyData = {};
    bodyData.objectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) bodyData.objectIds.push(this.props.selectedObjects[x].objectId);

    bodyData.shareStatus = 'Not Shared';

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'setShareStatus', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error changing the way the object is shared');
    if (undefined !== this.props.refreshVaultViewTab) this.props.refreshVaultViewTab();
    this.setState(
    {
      shareStatusDisplay: 'flex', 
      resetShareStatusDisplay: 'none',
      usersToShareDisplay: 'none',
      shareStatus: {permission: 'Not Shared'}
    });
    this.shareStatusRef.current.focus();
    this.context.postNotification('info', 'Share settings reset.');
  }

  async setShareStatusConfirmed(confirmed)
  {
    let shareStatus = (confirmed ? this.confirmThisShareStatus : this.state.shareStatus);
    this.setState({confirmationModalIsOpen: false, shareStatus: shareStatus});

    if (!confirmed)
    {
      this.shareStatusRef.current.focus();
      return;
    } 

    let bodyData = {};
    bodyData.objectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) bodyData.objectIds.push(this.props.selectedObjects[x].objectId);
    bodyData.shareStatus = shareStatus.permission;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'setShareStatus', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error changing the way the object is shared');
    if ('Not Shared' === shareStatus.permission || 'Share With All Users' === shareStatus.permission ||
        'Share With Domain' === shareStatus.permission)
    {
      this.setState(
      {
        usersToShareDisplay: 'none', 
        usersToShareWith: [],
        selectedUsers: [],
        shareStatus: shareStatus
      });
      this.shareStatusRef.current.focus();
    }
    if ('Share With Users' === shareStatus.permission)
    {
      this.getUsersToShareWith();
      this.setState({shareStatus: shareStatus, usersToShareDisplay: 'flex'});
      if (null !== this.usersToShareWithRef.current) this.usersToShareWithRef.current.focus();
    } 
    this.props.refreshVaultViewTab();
    this.context.postNotification('info', 'Share settings changed.');
  }

  setUsersToShareWith(selectedUsers, actionMetaD)
  {
    this.setState({selectedUsers: selectedUsers});
  }

  async usersToShareWithClosed()
  {
    if (this.originallySelectedUsers.length && this.state.selectedUsers.length && 
        this.originallySelectedUsers.length === this.state.selectedUsers.length)
    {
      let objectsAreEqual = true;
      for (let x = 0; x < this.originallySelectedUsers.length; x++)
      {
        let y = 0;
        for (y = 0; y < this.state.selectedUsers.length; y++)
        {
          if (this.originallySelectedUsers[x].apiUserId !== this.state.selectedUsers[y].apiUserId)
          {
            objectsAreEqual = false;
            break;
          }
        }
        if (y !== this.state.selectedUsers.length) break;
      }
  
      if (objectsAreEqual) return;
    }

    if (!this.originallySelectedUsers.length && !this.state.selectedUsers.length) return;

    if (!this.state.selectedUsers.length)
    {
      this.closeModal = this.setNotShared.bind(this);
      this.setState(
      {
        modalText: 'Are you sure you want to remove all of the users that this object is shared with?  If you do so, the share status will transition to Not Shared',
        confirmationModalIsOpen: true
      });

      return;
    }

    let bodyData = {};
    bodyData.objectIds = [];
    for (let x = 0; x < this.props.selectedObjects.length; x++) bodyData.objectIds.push(this.props.selectedObjects[x].objectId);
    bodyData.apiUserIds = [];
    for (let x = 0; x < this.state.selectedUsers.length; x++) bodyData.apiUserIds.push(this.state.selectedUsers[x].apiUserId);

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'shareObjectsWithUsers', bodyData);
    if ('success' !== result.status)
    {
      this.setState({saveButtonDisabled: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error sharing object with users');
    } 
    this.originallySelectedUsers = this.state.selectedUsers;
    this.context.postNotification('info', 'Object shared with specified users.');
  }
}

ObjectSharing.contextType = AppContext;

export default ObjectSharing